var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9144 5.67249L18 4.58603L15.4523 2.03754L14.3642 3.12526C15.3714 3.79927 16.2391 4.66483 16.9144 5.67249Z",
    fill: "#D40303"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7177 2.64365C3.90322 2.64365 0 6.54687 0 11.3613C0 16.1758 3.90322 20.0795 8.7177 20.0795C13.5322 20.0795 17.4354 16.1762 17.4354 11.3613C17.4354 6.54687 13.5318 2.64365 8.7177 2.64365ZM8.7177 19.0228C4.48669 19.0228 1.0567 15.5928 1.0567 11.3618C1.0567 7.13118 4.48711 3.70077 8.7177 3.70077C12.9487 3.70077 16.3787 7.13118 16.3787 11.3618C16.3787 15.5928 12.9487 19.0228 8.7177 19.0228Z",
    fill: "#D40303"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91573 1.77556C7.49711 1.65317 8.09944 1.58694 8.71728 1.58694C9.33554 1.58694 9.93788 1.65317 10.5188 1.77556V1.11748H11.034V0H6.401V1.1179H6.91615L6.91573 1.77556Z",
    fill: "#D40303"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71771 4.77802V11.3823H15.322C15.322 7.73519 12.3648 4.77802 8.71771 4.77802Z",
    fill: "#D40303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.21092cb4f68eea7b6e904053e3ed4c0c.svg";
export { ForwardRef as ReactComponent };